import React from 'react';
import { map } from 'lodash/fp';
import { Route } from 'react-router-dom';
import { RouteType } from '../../types';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

export const mapPrivateRoutes = map<RouteType, JSX.Element>(({
    path,
    title,
    exact,
    component,
    permissions,
    redirectRoute,
    allowedVenueTypes,
    childrenRoutes,
    scopeProvider,
}) => {
    return (
        <Route
            key={path}
            path={path}
        >
            <ProtectedRoute
                path={path}
                exact={exact}
                title={title}
                component={component}
                permissions={permissions}
                redirectRoute={redirectRoute}
                allowedVenueTypes={allowedVenueTypes}
                childrenRoutes={childrenRoutes}
                scopeProvider={scopeProvider}
            />
        </Route>
    );
});

export const mapPublicRoutes = map<Omit<RouteType, 'icon'>, JSX.Element>(({
    path,
    exact,
    component,
}) => (
    <PublicRoute
        key={path}
        path={path}
        exact={exact}
        component={component}
    />
));
